;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      type: String
    },
    value: {
      default: null
    },
    onChange: Function
  },
  data: function data() {
    return {
      fieldValue: this.value
    };
  },

  watch: {
    value: function value() {
      this.fieldValue = this.value;
    }
  },
  methods: {
    onFieldChange: function onFieldChange() {
      this.$emit("input", this.fieldValue);
      this.onChange({ name: this.name, value: this.fieldValue });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"ss-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldValue),expression:"fieldValue"}],staticClass:"ss-checkbox__input",attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":Array.isArray(_vm.fieldValue)?_vm._i(_vm.fieldValue,null)>-1:(_vm.fieldValue)},on:{"change":[function($event){var $$a=_vm.fieldValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.fieldValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.fieldValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.fieldValue=$$c}},function($event){$event.stopPropagation();return _vm.onFieldChange.apply(null, arguments)}]}}),_vm._v(" "),(_vm.label)?_c('span',{staticClass:"ss-checkbox__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56d8222f", __vue__options__)
  } else {
    hotAPI.reload("data-v-56d8222f", __vue__options__)
  }
})()}